import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import React from 'react';
import { css } from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import {
  CategoryHeaderWrapper, CategoryName, CategoryContent
} from './CategoryHeader';
import { theme } from '../Theme'

const innerWrapper = css`
  margin: 0 auto;

  .name {
    margin: 0 auto;
    margin-bottom: 1rem;
  }
`

const boxes = css`
 display: flex;
 justify-content: center;
 align-items: center;
 flex-wrap: wrap;

  > div {
    margin: 1rem;
  }
`

export default React.memo(function CategoryHeaderLoadingState() {
  const backgroundColor = '#e2e2e2';
  return (
    <MaxWidth style={{ margin: '35px auto' }}>
      <CategoryHeaderWrapper>
        <div className={innerWrapper}>
          <CategoryName
            color={backgroundColor}
            heightPx={14}
          />
          <CategoryContent>
            <LoadingLine
              color={backgroundColor}
              widthRem={10}
              heightPx={27}
              className="name"
            />
            <LoadingLine
              color={backgroundColor}
              widthRem={22}
              randomizeWidthBy={6}
              heightPx={10}
              count={3}
              className="name"
            />
            <div className={boxes}>
              <LoadingLine
                color={backgroundColor}
                widthRem={10}
                // randomizeWidthBy={5}
                count={4}
                heightPx={120}
                className={css`
              margin-bottom: 0.5rem;
            `}
              />
            </div>
          </CategoryContent>
        </div>
      </CategoryHeaderWrapper>
    </MaxWidth>
  );
});
